// Minimal open/close store for the (hidden, employee-only) lineage debug panel,
// mirroring the shape of utils/network-log/network-log-store.ts but without a
// ring buffer: this panel has no background capture, just an open flag that
// should survive an SPA navigation the same way the network log drawer's does.

import { LocalStorageKey } from "@/utils/local-storage-utils";

let panelOpen = false;
const listeners = new Set<() => void>();

function readPersistedOpen(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.localStorage.getItem(LocalStorageKey.LINEAGE_PANEL_OPEN) === "true";
  } catch {
    return false;
  }
}

function persistOpen(open: boolean): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(LocalStorageKey.LINEAGE_PANEL_OPEN, open ? "true" : "false");
  } catch {
    // Best-effort; a private window or blocked storage just loses the persisted flag.
  }
}

if (typeof window !== "undefined") {
  panelOpen = readPersistedOpen();
}

export function getLineagePanelOpen(): boolean {
  return panelOpen;
}

export function getServerLineagePanelOpen(): boolean {
  return false;
}

export function setLineagePanelOpen(open: boolean): void {
  if (panelOpen === open) {
    return;
  }
  panelOpen = open;
  persistOpen(open);
  listeners.forEach((listener) => listener());
}

export function subscribeToLineagePanel(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
